///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class UserManualTypes {
    public static readonly INTRO = 'USER_MANUAL_INTRO_CONTENT';
    public static readonly TABLE_CONTENT = 'USER_MANUAL_TABLE_OF_CONTENTS';
    public static readonly TABLE_FIGURES = 'USER_MANUAL_TABLE_OF_FIGURES';
    public static readonly CONTENT = 'USER_MANUAL_MAIN_CONTENT';
    public static readonly IMAGE = 'USER_MANUAL_IMAGES';

    public static readonly ALL_USER_MANUAL = [
        UserManualTypes.INTRO,
        UserManualTypes.TABLE_CONTENT,
        UserManualTypes.TABLE_FIGURES,
        UserManualTypes.CONTENT,
        UserManualTypes.IMAGE
    ];
}

export class ContextSensitiveHelp {
    public static readonly TOOLTIPS = 'CONTEXT_SENSITIVE_HELP_TOOLTIPS';
}
